import { render, staticRenderFns } from "./cpFile.vue?vue&type=template&id=6fec3d3a&scoped=true&"
import script from "./cpFile.vue?vue&type=script&lang=js&"
export * from "./cpFile.vue?vue&type=script&lang=js&"
import style0 from "./cpFile.vue?vue&type=style&index=0&id=6fec3d3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fec3d3a",
  null
  
)

export default component.exports